import React, { useState, useEffect } from 'react';
import{
  MenuItem, FormControl, Select, CardContent, Card
}from '@material-ui/core';
import InfoBox from '../InfoBox/InfoBox';
import Map from '../Map/Map';
import Table from '../Table/Table';
import { sortData } from '../../util/util';
import LineGraph from '../../util/Linegraph';
import 'leaflet/dist/leaflet.css';
import './App.css';


function App() {
  const [countries, setCountries]= useState([]);
  const [casesType, setCasesType] = useState('recovered');
  // https://disease.sh/v3/covid-19/countries
  const [country, setCountry] = useState("worldwide");
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({lat: 28.3949, lng : 84.1240});
  const[mapZoom, setMapZoom] = useState(4);
  const [mapCountries, setMapCountries] = useState([]);
  useEffect(()=>{
    fetch("https://disease.sh/v3/covid-19/all")
    .then(response=>response.json())
    .then(data =>{
      setCountryInfo(data);
    })
  },[]);

  useEffect(()=>{
    const getCountriesData = async()=>{
      await fetch("https://disease.sh/v3/covid-19/countries")
      .then((response)=> response.json())
      .then((data) =>{
        const countries = data.map((country)=>({
            name: country.country,
            value: country.countryInfo.iso2
          }));
          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
      });
    };
    getCountriesData();
      
  },[]);

  const cases_change = ()=>{
    setCasesType('cases')
  }

  const recovered_change = ()=>{
    setCasesType('recovered')
  }

  const death_change= ()=>{
    setCasesType('deaths')
  }

  const onCountryChange = async(event) => {
    const countryCode = event.target.value;
    setCountry(countryCode);
    const url = countryCode==='worldwide'
        ? "https://disease.sh/v3/covid-19/all" :
        `https://disease.sh/v3/covid-19/countries/${countryCode}`
    
    await fetch(url)
    .then(response => response.json())
    .then(data => {
      setCountry(countryCode)
      setCountryInfo(data);

      setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
      setMapZoom(4);
    })

    
  };
  const [nightmode, setNightMode]= useState(false);

  const onNightChange = ()=>{
    setNightMode( nightmode ? false : true)
  }
  return (
    <div className={nightmode ? 'App_night' : 'App'}>
      <div className="app_left">

        <div className='app_header'>
          <button className={nightmode ? 'night_mode_button_night' : 'night_mode_button'} onClick = {onNightChange}>{nightmode ? 'Day': 'Night'}</button>
          <h1>Covid 19 Tracker</h1>
          <FormControl className="app_dropdown">
            <Select
              variant="outlined"
              onChange={onCountryChange}
              value={country} >
                <MenuItem className= {nightmode ? 'menu_night' : 'menu'} value="worldwide"><p className= {nightmode ? 'men_night' : 'men'}>Worldwide</p></MenuItem>
                {
                  countries.map((country)=>(
                    <MenuItem class= {nightmode ? 'menu_night' : 'menu'} value = {country.value}>{country.name}</MenuItem>
                  ))
                }
            </Select>
          </FormControl>
        </div>

        <div className = "app_stats">
          <div className = 'cases_stats' onClick = {cases_change}>
          <InfoBox active = {casesType === 'cases'} onClick = {(e)=>setCasesType('cases')} night = {nightmode} title="Cases" cases={countryInfo.todayCases} total={countryInfo.cases}/>
          </div>
          <div className = 'recovered_stats' onClick = {recovered_change}>
          <InfoBox active = {casesType === 'recovered'} onClick = {(e)=>setCasesType('recovered')} night = {nightmode} title="Recovered" cases={countryInfo.todayRecovered} total={countryInfo.recovered}/>
          </div>
          <div className = 'death_stats' onClick={death_change}>
          <InfoBox active = {casesType === 'deaths'} onClick = {(e)=>setCasesType('deaths')} night = {nightmode} title="Deaths" cases={countryInfo.todayDeaths} total={countryInfo.deaths}/>
          </div>
          
          
          
        </div>
        <Map 
        night = {nightmode}
        countries={mapCountries}
        casesType = {casesType}
        center={mapCenter}
        zoom={mapZoom}/>
      </div>

      <div className="app_right">
        <Card>
          <CardContent>
              <h3>Live Casess by Country</h3>
              <Table night = {nightmode} countries={tableData}/>
              <h3>Worldwide new {casesType}</h3>
              <LineGraph casesType = {casesType}/>
            </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default App;



